import { create } from 'zustand';

interface LaunchDarklyAuthStore {
  identifiedEmail?: string;
  isReady: boolean;
  setReady: (email: string | undefined, isReady: boolean) => void;
}

export const useLaunchDarklyAuthStore = create<LaunchDarklyAuthStore>()(set => ({
  isReady: false,
  setReady: (identifiedEmail, isReady) => set({ identifiedEmail, isReady }),
}));
